export const verifyLinkIsValid = ({ link }: { link: string }) => {
  try {
    let normalized = link.trim();
    if (!/^https?:\/\//i.test(normalized)) {
      normalized = "http://" + normalized;
    }

    const url = new URL(normalized);

    return ["http:", "https:"].includes(url.protocol);
  } catch {
    return false;
  }
};

export const normalizeLink = (link: string) => {
  try {
    let normalized = link.trim();
    if (!/^https?:\/\//i.test(normalized)) {
      normalized = "http://" + normalized;
    }

    const url = new URL(normalized);

    return url;
  } catch {
    return link;
  }
}

export const getLinkInvoice = (type: 'NFC' | 'NFS' | 'NFE') => {

  const links = {
    'NFC': 'https://sped.fazenda.pr.gov.br/NFCe/webservices/sped/nfce/completa',
    'NFE': 'https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx',
    'NFS': 'https://www.nfse.gov.br/consultapublica'
  }

  return links[type];
}


export const calculateVariation = (
  previous: number | null | undefined,
  current: number | null | undefined
): number => {
  if (!previous || previous === 0) return 0;
  return (((current ?? 0) - previous) / previous) * 100;
};



function hexToRgb(hex: string) {
  hex = hex.replace('#', '')

  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('')
  }

  const bigint = parseInt(hex, 16)

  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  }
}

function rgbToHex(r: number, g: number, b: number) {
  return (
    '#' +
    [r, g, b]
      .map(x => {
        const hex = x.toString(16)
        return hex.length === 1 ? '0' + hex : hex
      })
      .join('')
  )
}

// RGB -> HSL
function rgbToHsl(r: number, g: number, b: number) {
  r /= 255
  g /= 255
  b /= 255

  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  let h = 0, s = 0
  const l = (max + min) / 2

  if (max === min) {
    h = s = 0
  } else {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      case b:
        h = (r - g) / d + 4
        break
    }

    h /= 6
  }

  return { h, s, l }
}

// HSL -> RGB
function hslToRgb(h: number, s: number, l: number) {
  let r, g, b

  if (s === 0) {
    r = g = b = l
  } else {
    const hue2rgb = (p: number, q: number, t: number) => {
      if (t < 0) t += 1
      if (t > 1) t -= 1
      if (t < 1 / 6) return p + (q - p) * 6 * t
      if (t < 1 / 2) return q
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
      return p
    }

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s
    const p = 2 * l - q

    r = hue2rgb(p, q, h + 1 / 3)
    g = hue2rgb(p, q, h)
    b = hue2rgb(p, q, h - 1 / 3)
  }

  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255),
  }
}

export function generateBrightColor(baseHex: string, lightnessIncrease = 0.12) {
  const { r, g, b } = hexToRgb(baseHex)
  const { h, s, l } = rgbToHsl(r, g, b)

  const newL = Math.min(1, l + lightnessIncrease)

  const newRgb = hslToRgb(h, s, newL)

  return rgbToHex(newRgb.r, newRgb.g, newRgb.b)
}

export function isValidCNPJ(cnpj: string) {
  if (!cnpj) return false;

  cnpj = cnpj.replace(/\D/g, "");

  if (cnpj.length !== 14) return false;

  if (/^(\d)\1+$/.test(cnpj)) return false;

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

  if (resultado !== Number(digitos.charAt(0))) return false;

  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

  return resultado === Number(digitos.charAt(1));
}